import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Observable, map } from 'rxjs';

import { OnboardingDiscardDialogComponent } from './onboarding-discard-dialog.component';

/**
 * Interface that the onboarding component implements so the guard can ask it
 * whether it's safe to navigate away. Returning true unconditionally allows
 * the navigation; false (or a dialog confirmation) is consulted only when
 * the wizard has unsaved changes.
 */
export interface CanDeactivateOnboarding {
  hasUnsavedChanges(): boolean;
}

export const nutritionOnboardingDiscardGuard: CanDeactivateFn<CanDeactivateOnboarding> = (
  component,
) => {
  if (!component?.hasUnsavedChanges?.()) {
    return true;
  }

  const dialog = inject(MatDialog);
  const ref = dialog.open(OnboardingDiscardDialogComponent, {
    width: '380px',
    autoFocus: false,
  });
  return ref.afterClosed().pipe(map((confirmed) => confirmed === true)) as Observable<boolean>;
};
